import {DateTimeFormatter, LocalDate} from "@js-joda/core";

function field(value: string) {
	return value === '{field}' ? '' : value;
}
export default {
	code: 'sk',
	messages: {
		alpha: (name: any, value: any) => `Hodnota môže obsahovať len písmená`,
		alpha_dash: (name: any, value: any) => `Hodnota môže obsahovať len písmená, číslice, bodky a podčiarknutie`,
		alpha_num: (name: any, value: any) => `Hodnota môže obsahovať len písmená a číslice`,
		alpha_spaces: (name: any, value: any) => `Hodnota môže obsahovať len písmená, číslice a medzery`,
		between: (name: any, { min, max }: any) => `Hodnota musí byť medzi ${min} a ${max}`,
		confirmed: (name: any, value: any) => `Hodnota nie je rovnaká`,
		digits: (name: any, { length }: any) => `Hodnota musí obsahovať ${length} ${length < 5 ? 'čísla' : 'čísiel'}`,
		dimensions: (name: any, { width, height }: any) => `Pole musí mať ${width} x ${height} pixelov`,
		email: (name: any, value: any) => `Email nie je v správnom tvare`,
		emailSLSP: (name: any, value: any) => `Email nie je v správnom tvare`,
		excluded: (name: any, value: any) => `Hodnota má nesprávnu hodnotu`,
		ext: (name: any, value: any) => `Príloha nie je platný súbor`,
		image: (name: any, value: any) => `Príloha nie je obrázok`,
		oneOf: (name: any, value: any) => `Hodnota je nesprávna`,
		max: (name: any, { length }: any) => `Hodnota môže obsahovať najviac ${length} znakov`,
		max_value: (name: any, { max }: any) => `Maximálne povolená hodnota je ${max}`,
		mimes: (name: any, value: any) => `Pole obsahuje nesprávny typ súboru`,
		min: (name: any, { length }: any) => `Hodnota musí obsahovať minimálne ${length} ${length < 4 ? 'znaky' : 'znakov'}`,
		min_value: (name: any, { min }: any) => `Hodnota musí byť minimálne ${min}`,
		numeric: (name: any, value: any) => `Zadaná hodnota nie je číslo`,
		regex: (name: any, value: any) => `Formát je nesprávny`,
		required: (name: any, value: any) => `Pole je povinné`,
		required_if: (name: any, value: any) => `Pole je povinné`,
		size: (name: any, { size }: any) => `Príloha musí byť menšia ako ${size}KB`,
		mobileNumber: (name: any) => `Telefónne číslo nie je v správnom tvare`,
		companyID: (name: any) => `Zadané IČO nie je validné. Prosím skontrolujte si ho.`,
		intOrFloat: (name: any) => `Zadaná hodnota nie je číslo`,
		amount: (name: any, { min_value }: any) => `Suma musí byť väčší ako ${min_value}`,
		mindate: (name: any, { min_date }: any) => `Dátum musí byť väčší ako ${LocalDate.parse(min_date).format(DateTimeFormatter.ofPattern('dd.MM.yyyy'))}`,
		maxdate: (name: any, { max_date }: any) => `Dátum musí byť menší ako ${LocalDate.parse(max_date).format(DateTimeFormatter.ofPattern('dd.MM.yyyy'))}`,
		startDate:(name: any, { max_date }: any) => `Dátum musí byť menší ako ${LocalDate.parse(max_date).format(DateTimeFormatter.ofPattern('dd.MM.yyyy'))}`,
		booleanNotNull:(name: any) => `Prosím vyberte si jednu z možností.`,
	},
};
